import { writable } from 'svelte/store';

export const helpScoutRedirectInfoStore = writable({});
